import React, { useEffect } from 'react';
import { Input, InputNumber, Table, Form, Button, message } from 'antd';

const ImportPreview = ({ data, setData, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ rows: data });
    form.validateFields().catch(() => {});
  }, [data, form]);

  const columns = [
    {
      title: 'Product',
      dataIndex: 'product',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'product']} rules={[{ required: true, message: 'Please enter the Product' }]}>
          <Input placeholder="Product" />
        </Form.Item>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'name']} rules={[{ required: true, message: 'Please enter the Product' }]}>
          <Input placeholder="Name" />
        </Form.Item>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'description']} rules={[{ required: true, message: 'Please enter the Description' }]}>
          <Input placeholder="Description" />
        </Form.Item>
      ),
    },
    {
      title: 'Sale Price',
      dataIndex: 'sale_price',
      render: (_, __, index) => (
        <Form.Item
          name={['rows', index, 'sale_price']}
          rules={[{ required: true, type: 'number', message: 'Sale Price must be a number' }]}
        >
          <InputNumber placeholder="sale_price" min={0} style={{ width: '100%' }} />
        </Form.Item>
      ),
    },
    {
      title: 'License Type',
      dataIndex: 'license_type',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'license_type']} rules={[{ required: true, message: 'Please enter the License Type' }]}>
          <Input placeholder="License Type" />
        </Form.Item>
      ),
    },
    {
      title: 'Bundle',
      dataIndex: 'bundle',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'bundle']} rules={[{ required: true, message: 'Please enter the Bundle' }]}>
          <Input placeholder="Bundle" />
        </Form.Item>
      ),
    },
    {
      title: 'Bundled Products',
      dataIndex: 'bundled_products',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'bundled_products']} rules={[{ required: true, message: 'Please enter the Bundle Products' }]}>
          <Input placeholder="Bundled Products" />
        </Form.Item>
      ),
    },
    {
      title: 'Version',
      dataIndex: 'version',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'version']} rules={[{ required: true, message: 'Please enter the Version'  }]}>
          <Input placeholder="Version" />
        </Form.Item>
      ),
    },
  ];

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setData(values.rows);
      await onSubmit(values.rows);
    } catch {
      message.error('Please enter valid data before submitting.');
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        size="small"
        rowKey={(record, index) => index}
      />
      <Button type="primary"  className="mt-16" onClick={handleSubmit}>
        Validate & Save Changes
      </Button>
    </Form>
  );
};

export default ImportPreview;
